import React from "react";
import { BackgroundImage, TeethLogo, ServiceBottomButton } from "../../Components"
import orthodontic_dentistry from "../../assets/Images/orthodontic-dentistry-home.jpg"

const OrthodonticDentistry = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.orthodontic_dentistry_heading} text={selectedLanguage?.txt_explore_our_services} mainClass='orthodontic-dentistry-background' />
            <TeethLogo heading={selectedLanguage?.orthodontic_dentistry_heading} />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={orthodontic_dentistry} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>
                        {selectedLanguage?.txt_orthodontists_specialize_in_tooth_aligment}
                    </p>
                    <p>
                        {selectedLanguage?.txt_the_result_of_orthodontic_treatment_can_be_remarkable}
                    </p>
                    <p>
                        {selectedLanguage?.txt_all_types_of_braces}
                    </p>
                    <ul>
                        <li>{selectedLanguage?.txt_invisalign}</li>
                        <li>{selectedLanguage?.txt_clear_and_metal_braces}</li>
                        <li>{selectedLanguage?.txt_lingual_braces}</li>
                    </ul>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default OrthodonticDentistry